import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Breadcrumbs from "../components/Breadcrumbs";
import Footer from "../components/Footer";
import AnimatedText from "../components/AnimatedText";
import Seo from "../components/Seo";

const HireMultipleLawyers = () => {
  const [showTop, setShowTop] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    const onScroll = () => {
      setShowTop(window.pageYOffset > 400);
      const doc = document.documentElement;
      const max = doc.scrollHeight - doc.clientHeight;
      const p = max > 0 ? doc.scrollTop / max : 0;
      setScrollProgress(p);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="info-page-wrapper font-inter">
      <Seo
        title="Hire Multiple Lawyers — Legal Platform"
        description="Retain multiple lawyers across practice areas, manage subscriptions and invoices, and scale legal support for your business."
        canonicalPath="/hire-multiple-lawyers"
        image="/favicon.png"
      />
      <Header />
      <Breadcrumbs />
      <main className="info-page-section py-5">
        <div
          className="info-page-main-card"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <h1 className="home-hero-title text-center"><AnimatedText text="Hire Multiple Lawyers for Your Business" /></h1>
          <div className="home-hero-text text-center">
            <AnimatedText text="Build a flexible legal team tailored to your company's needs. LegalPlatform allows you to hire and retain multiple lawyers across different practice areas — from corporate and employment to compliance, litigation, and intellectual property — all within one secure platform. Whether you need short-term advisory support or long-term retainers, you can structure your legal resources efficiently without expanding internal overhead." />
          </div>
        </div>

        <div className="info-page-list">
          <div
            className="info-page-block"
            data-aos="fade-up"
            data-aos-delay="150"
          >
            <h3 className="info-page-block-title"><AnimatedText text="How It Works" /></h3>
            <div className="info-page-block-text">
              <AnimatedText text="Your business can browse verified lawyers by expertise, compare services and pricing, and hire professionals based on specific legal requirements. You may retain multiple lawyers simultaneously for different departments or projects, communicate through secure chat, upload documents, and receive customized service proposals or invoices directly within the platform. All engagements, subscriptions, and payments are managed centrally, giving your company full visibility and control." />
            </div>
          </div>

          <div
            className="info-page-block"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <h3 className="info-page-block-title"><AnimatedText text="Why It Matters" /></h3>
            <div className="info-page-block-text">
              <AnimatedText text="Instead of relying on a single external firm or building a costly in-house team, LegalPlatform enables companies to create a scalable, on-demand legal network. This approach improves responsiveness, increases specialization, and ensures your business has the right legal expertise available whenever required." />
            </div>
          </div>

          <div
            className="info-page-block"
            data-aos="fade-up"
            data-aos-delay="250"
          >
            <h3 className="info-page-block-title"><AnimatedText text="Target Audience" /></h3>
            <div className="info-page-block-text">
              <AnimatedText text="This solution is designed for startups, SMEs, and large enterprises that require structured legal support across multiple business functions and jurisdictions, without the operational burden of traditional legal models." />
            </div>
          </div>
        </div>
      </main>
      {showTop && (
        <button
          type="button"
          className="scroll-top-btn"
          onClick={scrollToTop}
          aria-label="Scroll to top"
          style={{ "--progress": `${Math.round(scrollProgress * 100)}%` }}
        >
          <span className="scroll-top-ring" />
          <i className="bi bi-arrow-up-short" />
        </button>
      )}
      <Footer />
    </div>
  );
};

export default HireMultipleLawyers;
